import { Pipe, PipeTransform } from '@angular/core';
import { CustomDateFormatPipe } from './custom-date-format/custom-date-format.datepipe';

export interface DealField {
  custom_field_id: number;
  value: string | null;
}

@Pipe({
    name: 'combinedDealField',
    pure: true,
    standalone: false
})
export class CombinedDealFieldPipe implements PipeTransform {
  constructor(private customDatePipe: CustomDateFormatPipe) {}

  transform(dealFields: DealField[] | null | undefined, fieldId: number, fieldTypeId?: number): string {
    if (!dealFields || !dealFields.length) {
      return '';
    }

    const values = dealFields
      .filter(item => item?.custom_field_id === fieldId && item?.value != null && item?.value !== '')
      .map(item => {
        const val = item.value as string;
        // If it's a date field (fieldTypeId === 3), format it
        if (fieldTypeId === 3) {
          if (isNaN(Date.parse(val))) {
            return val; // not a parseable date — show raw value instead of throwing NG02100
          }
          return this.customDatePipe.transform(val);
        }
        return val;
      });

    return values.join(', ');
  }
}
